/**
 * Parent portal ID → URL prefix mapping
 *
 * Shared between slugResolver.ts (runtime) and nuxt.config.ts (build-time prerender
 * route discovery) so both stay in sync without duplication.
 */
export const PARENT_PATH_MAP: Record<string, string> = {
  'portal-djurfakta': 'djurfakta',
  'portal-hjalp-djuren': 'hjalp-djuren',
  'portal-klubbnytt': 'klubbnytt',
  'portal-vuxen-eller-pedagog': 'vuxen',
  'portal-aktuellt': 'aktuellt',
  'portal-vuxen': 'vuxen',
  'portal-om-oss': 'om-oss',
}
